"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyPropertyCondition = void 0;
const PropertyCondition_1 = require("./PropertyCondition");
class AnyPropertyCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property) {
        super(property);
    }
    isFulfilled(value) {
        const propertyResult = super.checkProperty(value);
        if (propertyResult.isFinal) {
            return propertyResult.result;
        }
        return { fulfilled: true };
    }
}
exports.AnyPropertyCondition = AnyPropertyCondition;
//# sourceMappingURL=AnyPropertyCondition.js.map